export interface SelectItems {
  readonly id: string;
  readonly label: string;
}

export enum SoftwareType {
  Application = 'application',
  System = 'system',
  None = '',
}
